import React from "react";
import useCartLifeCycle from "./cart/useCartLifeCycle";
import useSessionContext from "./user/useSessionContext";
import GlobalStyles from "../react-components/shared/GlobalStyles";
import TopLayer from "./topLayer/TopLayer";
import SiteFooter from "../react-components/footer/SiteFooter";
import usePopStatePageCode from "./shared/usePopStatePageCode";

const FarmyApp = () => {
  useCartLifeCycle();
  useSessionContext();
  usePopStatePageCode();

  return <>
    <GlobalStyles/>
    <TopLayer/>
    <SiteFooter/>
  </>;
};

export default FarmyApp;
